import { CFG_TEXTOS_PREDEFINIDOS } from './../../../../../models/CFG_TEXTOS_PREDEFINIDOS';
import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { ComponentDialog } from 'path-shared/models/component-dialog.model';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AuthorizationService } from 'path-shared/services/authorization/authorization-service';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { ConfirmationDialogService } from 'path-shared/components/confirmation-dialog/confirmation-dialog.service';
import { FormService } from 'path-shared/services/form/form.service';
import { Builder } from 'path-shared/models/builder';
import { TextosPredefindiosService } from '../../services/textos-prefedefinidos.service';

@Component({
  selector: 'app-textos-predefinidos-editor',
  templateUrl: './textos-predefinidos-editor.component.html',
  styleUrls: ['./textos-predefinidos-editor.component.scss']
})
export class TextosPredefinidosEditorComponent implements OnInit {

  secure_id: string;
  cfgTexto: CFG_TEXTOS_PREDEFINIDOS;
  dialogData: ComponentDialog;
  closeButtonText: string;

  @ViewChild('mainForm') private mainForm: ElementRef;

  constructor(
    private dialog: MatDialog,
    private confirmationDialogService: ConfirmationDialogService,
    public auth: AuthorizationService,
    private textosService: TextosPredefindiosService,
    private i18n: I18n,
    private toastr: ToastrService,
    public datepipe: DatePipe,
    public thisDialogRef: MatDialogRef<TextosPredefinidosEditorComponent>,
    private formService: FormService,
    @Inject(MAT_DIALOG_DATA) public data: ComponentDialog,
    ) {
      this.cfgTexto = Builder.cfgTexto();
      this.dialogData = data;
      this.secure_id = this.dialogData.id;
      if (this.dialogData.isReadOnly) {
        this.closeButtonText = this.i18n('Tancar');
      } else {
        this.closeButtonText = this.i18n('Llista');
      }
   }

  ngOnInit() {
    if (this.secure_id !== null) {
      this.textosService.getTexto(this.secure_id).subscribe(data => {
        this.cfgTexto = data;
      });
    }
  }

  save() {
    if (this.formService.allFieldsValid(this.mainForm)) {

      this.textosService.setTexto(this.cfgTexto).subscribe(result => {
        this.toastr.info(this.i18n('Texto guardado correctamente'));
        this.thisDialogRef.close(true);
      });
    } else {
      this.toastr.warning(this.i18n('Hi ha errors en el formulari!'));
      if (!this.mainForm.nativeElement.classList.contains('displayErrors')) {
        this.mainForm.nativeElement.classList.add('displayErrors');
      }
    }
  }

  cancel() {
    this.thisDialogRef.close(false);
  }

  remove() {
    this.confirmationDialogService.confirm(this.i18n('Confirmi'), this.i18n('Segur que vol esborrar el motiu?'))
    .then((confirmed) => {
        if (confirmed) {
          this.textosService.removeTexto(this.secure_id).subscribe(result => {
            this.toastr.success(this.i18n('Texto borrado correctamente'));
            this.dialog.closeAll();
            this.thisDialogRef.close(true);
          });
        }
      });
  }

}
